var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import PropTypes from "prop-types";
import { isNull, get, flatten, uniq } from "lodash";
import withAuth from "@irati/auth/helpers/auth/withAuth";
import categoriesService from "@irati/deals/services/dealCategory";
import { updatePrivateUserMetadata, getPrivateUserMetadata } from "@irati/user-metadata/services/UserMetadata";
import { UserTracking as tracking, UserFlowIds } from "@irati-tracking/onboarding";
import Loading from "@irati/ui/src/Loading";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { hangPromise } from "@irati/utils/promise";
import notify from "@irati/utils/notify";
import Card from "@irati/ui/src/Layout/Card";
import { H1, Body } from "@irati/ui/src/Typography";
import Spacing from "@irati/ui/src/Spacing";
import { RouterLink } from "@irati/ui/src/Link";
import Button from "@irati/ui/src/Button";
import Flex from "@irati/ui/src/Flex";
import { Strong } from "@irati/ui/src/Labels";
import ErrorText from "@irati/ui/src/ErrorText";
import SuccessText from "@irati/ui/src/SuccessText";
import { DEFAULT_CONFIG } from "@irati/user-metadata/constants/defaultPushConfig";
import CustomisationCategory from "../../components/CustomisationCategory";
import OnLeaveCustomisation from "../../components/OnLeaveCustomisation";
var MAX_FAVOURITE_CATEGORIES = 7;
var CategoriesCustomisation = /** @class */ (function (_super) {
    __extends(CategoriesCustomisation, _super);
    function CategoriesCustomisation(props) {
        var _this = _super.call(this, props) || this;
        _this.getMetadataConfig = function (metadata) {
            return (metadata === null || metadata === void 0 ? void 0 : metadata.config) || DEFAULT_CONFIG;
        };
        _this.toggleSelection = function (id) {
            var currentSelection = _this.state.currentSelection;
            var updatedSelection;
            if (currentSelection.includes(id)) {
                updatedSelection = currentSelection.filter(function (selectedId) { return selectedId !== id; });
                tracking.categoryDeselected({ category_id: id,
                    flow: UserFlowIds.CategoriesCustomisation });
                _this.setState({
                    showError: updatedSelection.length > MAX_FAVOURITE_CATEGORIES,
                    currentSelection: updatedSelection
                });
            }
            else {
                updatedSelection = currentSelection.concat(id);
                tracking.categorySelected({ category_id: id,
                    flow: UserFlowIds.CategoriesCustomisation });
                _this.setState({
                    showError: updatedSelection.length > MAX_FAVOURITE_CATEGORIES,
                    currentSelection: updatedSelection
                });
            }
        };
        _this.hasChanged = function () {
            var _a = _this.state, _b = _a.metadata, metadata = _b === void 0 ? {} : _b, currentSelection = _a.currentSelection;
            var favouriteCategoryIds = get(metadata, "config.favouriteCategoryIds", []);
            return currentSelection.sort().join("") !== (favouriteCategoryIds || []).sort().join("");
        };
        _this.saveChanges = function () {
            var _a = _this.props, userUuid = _a.auth.user.uuid, formatMessage = _a.formatMessage;
            var _b = _this.state, metadata = _b.metadata, currentSelection = _b.currentSelection;
            var favouriteCategoryIds = get(metadata, "config.favouriteCategoryIds", []);
            tracking.categoriesSaved({
                category_ids: currentSelection,
                previous_category_ids: favouriteCategoryIds,
                flow: UserFlowIds.CategoriesCustomisation
            });
            var saving = updatePrivateUserMetadata(userUuid, __assign(__assign({}, metadata), { config: __assign(__assign({}, _this.getMetadataConfig(metadata)), { favouriteCategoryIds: currentSelection }), uuid: userUuid })).then(function (data) {
                _this.setState({ metadata: data, saving: null, showError: false, saved: true });
                setTimeout(function () {
                    _this.setState({
                        saved: false
                    });
                }, 5000);
            }).catch(function () {
                notify.error({ message: formatMessage({ id: "account.customisation.interests.error" }) });
                _this.setState({ saving: null });
            });
            _this.setState({ saving: saving });
        };
        _this.resetChanges = function () {
            var currentSelection = _this.state.currentSelection;
            tracking.categoriesReset({
                reset_category_ids: currentSelection,
                flow: UserFlowIds.CategoriesCustomisation
            });
            _this.setState({
                showError: false,
                currentSelection: []
            });
        };
        _this.abandonChanges = function () {
            var _a = _this.state, metadata = _a.metadata, currentSelection = _a.currentSelection;
            var favouriteCategoryIds = get(metadata, "config.favouriteCategoryIds", []);
            tracking.categoryChangesAbandoned({
                abandoned_category_ids: currentSelection,
                reset_to_category_ids: favouriteCategoryIds,
                flow: UserFlowIds.CategoriesCustomisation
            });
        };
        _this.state = {
            load: hangPromise(),
            saving: null,
            metadata: null,
            currentSelection: [],
            showError: false,
            saved: false
        };
        return _this;
    }
    CategoriesCustomisation.prototype.componentDidMount = function () {
        var _this = this;
        var uuid = this.props.auth.user.uuid;
        var load = Promise.all([categoriesService.listForCurrentPackage(), getPrivateUserMetadata(uuid, { fetchPolicy: "no-cache" })])
            .then(function (_a) {
            var _b;
            var categories = _a[0], metadata = _a[1];
            var selectableCategories = categories.filter(function (_a) {
                var type = _a.type, isGeolocationRelated = _a.isGeolocationRelated;
                return isNull(type) && !isGeolocationRelated;
            });
            var selectableTags = uniq(flatten(selectableCategories.map(function (_a) {
                var tags = _a.tags;
                return tags;
            }))
                .filter(function (_a) {
                var filterable = _a.filterable;
                return filterable === true;
            }).map(function (_a) {
                var tagUuid = _a.uuid;
                return tagUuid;
            }));
            var favouriteCategories = ((_b = metadata === null || metadata === void 0 ? void 0 : metadata.config) === null || _b === void 0 ? void 0 : _b.favouriteCategories) || [];
            var startingSelection = favouriteCategories.map(function (_a) {
                var tagUuid = _a.uuid;
                return tagUuid;
            }).filter(function (tag) { return selectableTags.includes(tag); });
            _this.setState({
                categories: selectableCategories,
                metadata: metadata,
                currentSelection: startingSelection
            });
        });
        this.setState({ load: load });
    };
    CategoriesCustomisation.prototype.render = function () {
        var _this = this;
        var apps = this.context.apps;
        var _a = this.state, load = _a.load, saving = _a.saving, categories = _a.categories, currentSelection = _a.currentSelection, showError = _a.showError, saved = _a.saved;
        var selectedDisplay = currentSelection.length + "/" + MAX_FAVOURITE_CATEGORIES + " ";
        var SelectedSummaryComponent = showError ? ErrorText : Flex;
        var hasChanged = this.hasChanged();
        var header = (React.createElement(Strong, null,
            React.createElement(FormattedMessage, { id: "account.customisation.interests.rowHeader" })));
        var link = (React.createElement(RouterLink, { to: "/discover", app: apps.PERKS },
            React.createElement(FormattedMessage, { id: "account.customisation.interests.linkText" })));
        return (React.createElement(React.Fragment, null,
            React.createElement(Card, { tiny: true, noBorder: true },
                React.createElement(H1, { marginBottom: 2 },
                    React.createElement(FormattedMessage, { id: "account.customisation.interests.header" })),
                React.createElement(Body, null,
                    React.createElement(FormattedMessage, { id: "account.customisation.interests.description", values: {
                            header: header,
                            link: link
                        } })),
                React.createElement(Loading, { load: load },
                    React.createElement(Spacing, { marginTop: 2 },
                        React.createElement(SelectedSummaryComponent, null,
                            selectedDisplay,
                            "\u00A0",
                            React.createElement(FormattedMessage, { id: "account.customisation.interests.selectedLabel" }))),
                    categories &&
                        categories.map(function (category) {
                            return React.createElement(CustomisationCategory, { key: category.uuid, category: category, toggleSelection: _this.toggleSelection, selection: currentSelection });
                        }),
                    showError && React.createElement(ErrorText, null,
                        React.createElement(FormattedMessage, { id: "account.customisation.interests.errorMessage" })),
                    React.createElement(Flex, { marginTop: 1 },
                        React.createElement(Button, { primary: true, disabled: !!saving || showError || !hasChanged, onClick: this.saveChanges },
                            React.createElement(FormattedMessage, { id: "account.customisation.interests.saveLabel" })),
                        React.createElement(Button, { marginLeft: 2, disabled: !!saving || currentSelection.length === 0, onClick: this.resetChanges },
                            React.createElement(FormattedMessage, { id: "account.customisation.interests.resetLabel" }))),
                    saved && (React.createElement(SuccessText, { marginTop: 1 },
                        React.createElement(FormattedMessage, { id: "account.customisation.interests.saved", values: {
                                link: link
                            } }))))),
            React.createElement(OnLeaveCustomisation, { block: hasChanged, trackLeave: this.abandonChanges })));
    };
    CategoriesCustomisation.contextTypes = {
        apps: PropTypes.object.isRequired
    };
    return CategoriesCustomisation;
}(Component));
export default injectIntl(withAuth(CategoriesCustomisation));
